import { render, staticRenderFns } from "./movebox.vue?vue&type=template&id=06547f63&scoped=true&"
import script from "./movebox.vue?vue&type=script&lang=js&"
export * from "./movebox.vue?vue&type=script&lang=js&"
import style0 from "./movebox.vue?vue&type=style&index=0&id=06547f63&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06547f63",
  null
  
)

export default component.exports